import {
  FONT_TYPES,
  mediaMixin,
  ModalDialog,
  spaceMixin,
  Spacer,
  Text,
  token,
  typographyMixin,
} from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const StyledModalDialog = styled(ModalDialog)`
  [class*='DialogBody'] {
    padding: 0px 0px !important;

    :after {
      height: 0 !important;
    }
  }
`;

export const StyledBackground = styled.div`
  align-items: center;
  background-color: ${token('colors.blue100')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: ${spaceMixin('sm')};
`;

export const StyledSpacerMediaObjectWrapper = styled(Spacer)`
  margin-bottom: ${spaceMixin('lg')};
  padding: 0px ${spaceMixin('lg')};

  &:first-child {
    margin: ${spaceMixin('lg')} 0px;
  }

  &:last-child {
    margin-bottom: ${spaceMixin(1.5)};
  }

  ${mediaMixin(
    'md_lte',
    css`
      padding: 0px;
    `,
  )}
`;

export const StyledWidgetSpacerMediaObjectWrapper = styled(Spacer)`
  margin-bottom: ${spaceMixin('lg')};

  &:first-child {
    margin: ${spaceMixin('lg')} 0px;
  }

  &:last-child {
    margin-bottom: ${spaceMixin(1.5)};
  }

  ${mediaMixin(
    'md_lte',
    css`
      padding: 0px;
    `,
  )}
`;

export const StyledSpacerUpsellInfoWrapper = styled(Spacer)`
  margin-left: ${spaceMixin('xs')};
`;

export const StyledTextUpsellInfo = styled(Text)`
  font-weight: ${token('fontWeights.bodyHeading')};
  ${typographyMixin({ fontType: FONT_TYPES.bodyHeading })}
`;

export const StyledTextFinePrint = styled(Text)`
  font-style: italic;
  line-height: 20px;
  text-align: center;
`;
